import {Observer, PageContainer, SubNavBar_Auto} from "web-vcore";
import React from "react";
import {Switch} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {Me} from "../Server/DB/users.js";
import {store} from "../Store/index.js";
import {EntitiesUI} from "./Content/Entities";
import {ScenesUI} from "./Content/Scenes.js";
import {StoriesUI} from "./Content/Stories.js";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.64, .06, .12, .18];

export const ContentPage = observer_mgl((props: {})=>{
	const currentSubpage = store.main.content.subpage;
	const page = "content";

	return (
		<>
			<SubNavBar_Auto page={page}/>
			<Switch>
				<ScenesUI/>
				{currentSubpage == "entities" && <EntitiesUI/>}
				{currentSubpage == "stories" && <StoriesUI_Outer/>}
			</Switch>
		</>
	);
});

const StoriesUI_Outer = observer_mgl(()=>{
	const user = Me();
	if (user == null) return <PageContainer>You must be signed in to access this page.</PageContainer>;
	
	return <StoriesUI user={user}/>;
});